import React from "react";
import { FileText, ShieldCheck, Upload } from "lucide-react";

/**
 * DocumentsScreen — secure document vault mockup.
 */
export const DocumentsScreen = () => {
  const docs = [
    { name: "Business License", status: "Verified", icon: FileText },
    { name: "Tax Returns 2024", status: "Verified", icon: FileText },
    { name: "Bank Statements", status: "Auto-Synced", icon: ShieldCheck },
    { name: "Voided Check", status: "Uploaded", icon: FileText },
  ];

  return (
    <div
      className="relative flex h-full w-full flex-col overflow-hidden bg-gradient-to-b from-[#080808] to-[#050505] px-5 pb-5 pt-14"
      data-testid="app-screen-documents"
    >
      <div className="absolute left-0 right-0 top-3 flex items-center justify-between px-8 text-[10px] font-medium text-white/70">
        <span>9:41</span>
        <span>●●●</span>
      </div>

      <div className="pt-3">
        <span className="text-[10px] uppercase tracking-widest text-text-muted">
          Secure Vault
        </span>
        <h3 className="mt-1 font-display text-xl font-semibold leading-tight text-white">
          Documents
        </h3>
        <div className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-brand-emerald/25 bg-brand-emerald/10 px-2 py-0.5">
          <ShieldCheck className="h-3 w-3 text-brand-emerald" />
          <span className="text-[9px] font-medium text-brand-emerald">
            256-bit encrypted
          </span>
        </div>
      </div>

      <div className="mt-4 flex flex-col gap-2">
        {docs.map((d) => {
          const Icon = d.icon;
          return (
            <div
              key={d.name}
              className="flex items-center gap-3 rounded-xl border border-white/[0.06] bg-white/[0.02] p-3"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-emerald/10">
                <Icon className="h-4 w-4 text-brand-emerald" />
              </div>
              <div className="flex flex-1 flex-col">
                <span className="text-xs font-medium text-white">{d.name}</span>
                <span className="text-[9px] text-brand-emerald">
                  {d.status}
                </span>
              </div>
              <span className="text-[9px] text-text-muted">✓</span>
            </div>
          );
        })}
      </div>

      {/* Upload CTA */}
      <div className="mt-3 flex items-center justify-center gap-2 rounded-xl border border-dashed border-white/[0.10] bg-white/[0.01] p-3 text-text-muted">
        <Upload className="h-3.5 w-3.5" />
        <span className="text-[10px]">Drop or tap to upload</span>
      </div>

      <div className="mt-auto flex items-center justify-around rounded-2xl border border-white/[0.06] bg-white/[0.02] px-2 py-2">
        {[
          { label: "Home", active: false },
          { label: "Score", active: false },
          { label: "Offers", active: false },
          { label: "Docs", active: true },
        ].map((tab) => (
          <div
            key={tab.label}
            className={
              tab.active
                ? "flex flex-col items-center gap-0.5 text-brand-emerald"
                : "flex flex-col items-center gap-0.5 text-text-muted"
            }
          >
            <span className="h-1.5 w-1.5 rounded-full bg-current" />
            <span className="text-[9px] font-medium">{tab.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentsScreen;
